import type { FunnelStep } from '../types/api';
import { getEventNameLabel } from './labels';

export function buildFunnelView(steps: readonly FunnelStep[]) {
  const openings = steps.find(step => step.event === 'checkout_opened')?.uniqueSessions ?? 0;
  const maximum = Math.max(0, ...steps.map(step => step.uniqueSessions));

  return {
    hasData: maximum > 0,
    hasBase: openings > 0,
    rows: steps.map(step => ({
      event: step.event,
      label: getEventNameLabel(step.event),
      count: step.uniqueSessions,
      // O zero retornado pela API sem aberturas nao representa conversao de 0%.
      rate: openings > 0 && Number.isFinite(step.rate) ? step.rate : null,
      widthPercent: maximum > 0 ? (step.uniqueSessions / maximum) * 100 : 0
    }))
  };
}
